import CryptoJS from 'crypto-js';

function styleStrToObj(str) {
  const obj = {}
  const s = str.toLowerCase().replace(/-(.)/g, function (m, g) {
    return g.toUpperCase();
  }).replace(/;\s?$/g, "").split(/:|;/g);
  for (var i = 0; i < s.length; i += 2) {
    obj[s[i].replace(/\s/g, "")] = s[i + 1].replace(/^\s+|\s+$/g, "");
  }
  return obj;
}

export {
  styleStrToObj
}


//加密
export function encrypt(word, keyStr = 'pVhrLsGxZQpWoMHD') {
  var key = CryptoJS.enc.Utf8.parse(keyStr);
  var srcs = CryptoJS.enc.Utf8.parse(word);
  var encrypted = CryptoJS.AES.encrypt(srcs, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
}
//解密
export function decrypt(word, keyStr = 'pVhrLsGxZQpWoMHD') {
  var key = CryptoJS.enc.Utf8.parse(keyStr);
  var decrypt = CryptoJS.AES.decrypt(word, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return CryptoJS.enc.Utf8.stringify(decrypt).toString();
}


// 使用 Promise 和 async/await
export const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));



export function isOdd(num) {
  return num % 2 !== 0;
}

export function isEven(num) {
  return num % 2 === 0;
}
